import {UpdatePlanCp} from "../../types/api/planRoute/cp.types";
import apiCall from "../../utils/apiCall";
import {apiUrls} from "../../constants/apiUrls";

export const cpService = {
    update: (id: string, planCp: UpdatePlanCp) =>
        apiCall.put(apiUrls.planRoute.cp.update(id), planCp)    
}